import { styled } from '@mui/system';

import { theme } from '../../assets/styles'

const Theme = theme as { [key: string]: any };

type InputWrapperProps = {
    invalid: boolean
}

export const InputWrapper = styled("div")<InputWrapperProps>`
    div {
      width: fit-content !important;
      input {
        width: 43px !important;
        height: 43px !important;
        margin-right: 16px;
        border: 1px solid !important;
        border-radius: 4px !important;
        font-size: 16px;
        border-color: ${({invalid}) => `${invalid ? `${Theme.errorColor}` : `${Theme.primary}`}`} !important;
        :focus{
          border: ${() => `${`2px solid ${Theme.darkYellow}`}`} !important;
        }
      }
    }
  
`